import React from 'react';
import { Box } from '@razorpay/blade/components';
import { useHistory, useLocation, Route, Switch, Redirect } from 'react-router-dom';
import { routePaths } from 'components/Routes/data';
import { WorkflowLayout, SideNavContainer } from './components/WorkflowLayout';
import { SideNav, NavItemProps } from './components/SideNav';
import { MyFlowsView } from './components/MyFlowsView';
import { ActivityView } from './components/ActivityView';
import { EditWorkflowView } from './components/EditWorkflowView';
import { CreateWorkflowView } from './components/CreateWorkflowView';

const AIWorkflow = () => {
  const history = useHistory();
  const location = useLocation();
  const pathname = location.pathname;

  const isBuilderView =
    pathname === routePaths.aiWorkflow.create || pathname === routePaths.aiWorkflow.edit;

  const handleBackButtonClick = () => {
    window.location.href = '/dashboard';
  };

  const handleCreateClick = () => {
    history.push(routePaths.aiWorkflow.create);
  };

  if (pathname === routePaths.aiWorkflow.root) {
    return <Redirect to={routePaths.aiWorkflow.myFlows} />;
  }

  if (isBuilderView) {
    return (
      <WorkflowLayout
        title="AI Workflow Automation"
        onBackButtonClick={() => history.push(routePaths.aiWorkflow.myFlows)}>
        <Box
          as="section"
          flexGrow={1}
          height="100%"
          display="flex"
          flexDirection="column"
          backgroundColor="surface.background.gray.moderate"
          marginTop="spacing.0">
          <Switch>
            <Route path={routePaths.aiWorkflow.create} exact>
              <CreateWorkflowView />
            </Route>
            <Route path={routePaths.aiWorkflow.edit}>
              <EditWorkflowView />
            </Route>
          </Switch>
        </Box>
      </WorkflowLayout>
    );
  }

  const navItems: NavItemProps[] = [
    {
      text: 'My flows',
      href: routePaths.aiWorkflow.myFlows,
      isActive: pathname === routePaths.aiWorkflow.myFlows,
    },
    {
      text: 'Activity',
      href: routePaths.aiWorkflow.activity,
      isActive: pathname === routePaths.aiWorkflow.activity,
    },
  ];

  return (
    <WorkflowLayout title="AI Workflow Automation" onBackButtonClick={handleBackButtonClick}>
      <SideNavContainer>
        <SideNav navItems={navItems} onCreateClick={handleCreateClick} />
      </SideNavContainer>
      <Box
        as="section"
        flexGrow={1}
        height="100%"
        display="flex"
        flexDirection="column"
        backgroundColor="surface.background.gray.moderate"
        margin="spacing.0"
        padding="spacing.0">
        <Switch>
          <Route path={routePaths.aiWorkflow.myFlows} exact>
            <MyFlowsView />
          </Route>
          <Route path={routePaths.aiWorkflow.activity} exact>
            <ActivityView />
          </Route>
        </Switch>
      </Box>
    </WorkflowLayout>
  );
};

export { AIWorkflow };
